import { MAX_FILE_SIZE, ALLOWED_FILE_TYPES } from './constants';

export const validatePhoneNumber = (phone: string): boolean => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  // Check if it's a valid phone number (at least 10 digits)
  return cleaned.length >= 10;
};

export const validateFile = (file: File): { valid: boolean; error?: string } => {
  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    return {
      valid: false,
      error: `File size exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB limit`,
    };
  }

  // Check file type
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return {
      valid: false,
      error: 'Only image files (JPEG, PNG, WebP) are allowed',
    };
  }

  return { valid: true };
};

export const validateFiles = (files: File[]): { valid: boolean; error?: string } => {
  if (files.length === 0) {
    return {
      valid: false,
      error: 'At least one file is required',
    };
  }

  for (const file of files) {
    const validation = validateFile(file);
    if (!validation.valid) {
      return validation;
    }
  }

  return { valid: true };
};

